import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, inject } from '@angular/core';
import { IdAndHeader, ListFilterService } from 'compob2b-libs';

@Component({
  selector: 'app-catalog-mobile-filter',
  templateUrl: './catalog-mobile-filter.component.html',
  styleUrls: ['./catalog-mobile-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CatalogMobileFilterComponent {
  @Input() filter: ListFilterService;
  @Input() catalog: IdAndHeader;
  isOpen = false;

  private readonly cdr = inject(ChangeDetectorRef);

  open(): void {
    this.isOpen = true;
    this.cdr.markForCheck();
  }

  close(): void {
    this.isOpen = false;
    this.cdr.markForCheck();
  }
}
